import { Router } from "@angular/router";
import { Map, FeatureGroup, latLng } from "leaflet";
import { ContactPlace } from "../../../core/models";
import { ContactMarkerBuilder } from "../builders";
import { StopsLayerService } from "./stops-layer.service";
import { HttpService } from "../../../core/services";

export class ContacPlacesLayerService {
  readonly contactPlacesLayer = new FeatureGroup;
  private contactPlaces: ContactPlace[] = [];
  private router!: Router;
  private map!: Map;
  private stopsLayerService!: StopsLayerService;
  private httpService!: HttpService;
  private activeMarkerId: number | undefined;

  init(router: Router, map: Map, httpService: HttpService, stopsLayerService: StopsLayerService) {
    this.router = router;
    this.map = map;
    this.httpService = httpService;
    this.stopsLayerService = stopsLayerService;
  }

  selectMarker(id: number | undefined) {
    this.activeMarkerId = id;
  }

  addContactPlaces() {
    this.contactPlacesLayer.clearLayers();
    if (this.map.getZoom() > 14) {
      if (this.contactPlaces.length == 0) {
        this.httpService.getContactPlaces().subscribe(places => {
          this.contactPlaces = places;
          this.buildMarkers();
        });
      }
      else
        this.buildMarkers();
    }
  }

  private buildMarkers() {
    this.contactPlaces.forEach(place => {
      const selected = place.id === this.activeMarkerId;
      const latlng = latLng(place.lat, place.lon);
      if (this.map?.getBounds().contains(latlng)) {
        const marker = ContactMarkerBuilder.buildMarker(place);

        marker.on('click', () => this.router.navigate([`contactPlaces/${place.id}`]));
        marker.on('mouseover', () => {
          if (!this.stopsLayerService.stopsLayer.isPopupOpen())
            marker.openPopup();
        });
                
        this.contactPlacesLayer.addLayer(marker);

        if (selected || this.activeMarkerId == place.id && !marker.isPopupOpen)
          marker.openPopup();
      }
    });
  }    
}
